import React, { useEffect, useState } from 'react';
import { Link } from "@sitecore-jss/sitecore-jss-react";
import { GenerateIdForGA } from "../../types/helpers";

const IvecoBusMobileMenu = ({ sublinks, mainTitle, themeOption }) => {
  // const toggleActiveClass = (event) => {
  //   const linkToggle = event.currentTarget.querySelector(".iveco-bus-link-toggle");
  //   if (linkToggle) {
  //     linkToggle.classList.toggle("active");
  //   }
  // };

  return (
    <div className='iveco-bus-menu--mobile'>
      <p className='iveco-bus-menu--title'>{mainTitle}</p>
      {sublinks.map((item, i) => {
        return (
          <div key={i} className="link iveco-bus-link">
            <Link field={item?.fields?.Link} className="iveco-bus-link-toggle" >
              <span>{item?.fields?.["Main Title"]?.value}</span>
            </Link>
            <div className="links-content">
              <ul>
                {item?.fields?.Sublinks?.map((el, x) => (
                  <li key={x}>
                    <Link
                      className="links-link"
                      field={el?.fields?.Link}
                      key={x}
                      aria-label="_"
                      id={GenerateIdForGA("header", el?.fields?.["Main Title"]?.value)}
                    >
                      <span>{el?.fields?.["Main Title"]?.value}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default IvecoBusMobileMenu;